import { SpeakersResponse } from './types';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { reshapeSpeakersToObj, ReshapedSpeakers } from './reshape';
import { client } from '../';

type UseSpeakers = (eventId: number) => {
    data: ReshapedSpeakers | null;
    error: Error;
    isLoading: boolean;
    isSuccess: boolean;
};

export async function fetchSpeakers(eventId: number) {
    return (await client().get(`/api/v2/agenda/events/${eventId}/speakers`))
        .data as SpeakersResponse;
}

const useSpeakers: UseSpeakers = eventId => {
    const { data, error, isLoading, isSuccess } = useQuery<SpeakersResponse, Error>(
        ['speakers', eventId],
        () => fetchSpeakers(eventId),
        {
            enabled: !!eventId,
        }
    );

    return useMemo(
        () => ({
            data: data ? reshapeSpeakersToObj(data) : {},
            error,
            isLoading,
            isSuccess,
        }),
        [data, error, isLoading, isSuccess]
    );
};

export default useSpeakers;
